import React from 'react';
import {
  SimpleGrid,
  Card,
  CardBody,
  Stat,
  StatLabel,
  StatNumber,
  Text,
  Spinner,
  Flex,
} from '@chakra-ui/react';
import { IDifalCarteiraKpis, IDifalResumo } from '../../../../../../types/icms';
import { formatCurrency, toNumber } from '../../../../../../utils/FormatFunctions';

interface DifalCarteiraKpisProps {
  data?: IDifalCarteiraKpis;
  isLoading?: boolean;
}

export function DifalCarteiraKpisCards({ data, isLoading }: DifalCarteiraKpisProps) {
  if (isLoading && !data) {
    return (
      <Flex justify="center" py={4}>
        <Spinner color="primary" />
      </Flex>
    );
  }
  if (!data) return null;

  return (
    <SimpleGrid columns={{ base: 1, sm: 3 }} spacing={3} mb={4}>
      <Card borderLeft="4px solid" borderLeftColor="#F57C00" bg="#FFF3E0">
        <CardBody p={4}>
          <Stat>
            <StatLabel fontSize="11px" color="gray.600" textTransform="uppercase" fontWeight="bold">
              Empresas com DIFAL
            </StatLabel>
            <StatNumber fontSize="24px" color="#F57C00">
              {data.empresas_com_difal}
            </StatNumber>
          </Stat>
        </CardBody>
      </Card>
      <Card borderLeft="4px solid" borderLeftColor="#1976D2" bg="#E3F2FD">
        <CardBody p={4}>
          <Stat>
            <StatLabel fontSize="11px" color="gray.600" textTransform="uppercase" fontWeight="bold">
              Total DIFAL
            </StatLabel>
            <StatNumber fontSize="24px" color="#1976D2">
              {formatCurrency(toNumber(data.total_difal))}
            </StatNumber>
          </Stat>
        </CardBody>
      </Card>
      <Card borderLeft="4px solid" borderLeftColor="#9C27B0" bg="#F3E5F5">
        <CardBody p={4}>
          <Stat>
            <StatLabel fontSize="11px" color="gray.600" textTransform="uppercase" fontWeight="bold">
              Notas no período
            </StatLabel>
            <StatNumber fontSize="24px" color="#9C27B0">
              {data.qtd_notas}
            </StatNumber>
          </Stat>
        </CardBody>
      </Card>
    </SimpleGrid>
  );
}

interface DifalResumoEmpresaProps {
  data?: IDifalResumo;
  isLoading?: boolean;
}

export function DifalResumoEmpresaCards({ data, isLoading }: DifalResumoEmpresaProps) {
  if (isLoading && !data) {
    return (
      <Flex justify="center" py={4}>
        <Spinner color="primary" />
      </Flex>
    );
  }
  if (!data) return null;

  return (
    <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} spacing={3} mb={4}>
      <Card>
        <CardBody p={4}>
          <Text fontSize="11px" color="gray.500" textTransform="uppercase" fontWeight="bold">
            Notas DIFAL
          </Text>
          <Text fontSize="20px" fontWeight="bold">
            {data.qtd_notas}
          </Text>
        </CardBody>
      </Card>
      <Card borderLeft="4px solid" borderLeftColor="#1976D2">
        <CardBody p={4}>
          <Text fontSize="11px" color="gray.500" textTransform="uppercase" fontWeight="bold">
            DIFAL Entrada
          </Text>
          <Text fontSize="16px" fontWeight="bold" color="#1976D2">
            {formatCurrency(toNumber(data.total_difal_entrada))}
          </Text>
          <Text fontSize="10px" color="gray.500" mt={1}>
            recolhido ao próprio estado
          </Text>
        </CardBody>
      </Card>
      <Card borderLeft="4px solid" borderLeftColor="#2E7D32">
        <CardBody p={4}>
          <Text fontSize="11px" color="gray.500" textTransform="uppercase" fontWeight="bold">
            DIFAL Saída
          </Text>
          <Text fontSize="16px" fontWeight="bold" color="#2E7D32">
            {formatCurrency(toNumber(data.total_difal_saida))}
          </Text>
          <Text fontSize="10px" color="gray.500" mt={1}>
            recolhido ao estado de destino
          </Text>
        </CardBody>
      </Card>
      <Card borderLeft="4px solid" borderLeftColor="#F57C00">
        <CardBody p={4}>
          <Text fontSize="11px" color="gray.500" textTransform="uppercase" fontWeight="bold">
            Total DIFAL
          </Text>
          <Text fontSize="16px" fontWeight="bold" color="#F57C00">
            {formatCurrency(toNumber(data.total_difal))}
          </Text>
        </CardBody>
      </Card>
    </SimpleGrid>
  );
}
